import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export interface GdprModalData {
  countryCode: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-gdpr-modal',
  standalone: true,
  imports: [ButtonModule, ToggleSwitchModule, FormsModule, TranslateModule],
  templateUrl: './gdpr-modal.component.html',
  styleUrl: './gdpr-modal.component.scss'
})
export class GdprModalComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(DynamicDialogConfig<GdprModalData>);
  readonly country = this.dialogConfig.data?.countryCode;
  checked = false;

  accept(): void {
    this.dialogRef.close(this.checked);
  }
}
